import { alertWithMessage } from "components/modal/message_modal";
import { MaxButton } from "components/view/button";
import {
  CheckWithPrefix,
  CheckWithPrefixResponse,
} from "lib/infomation_vender/document";
import {
  getReturnToLossDisplayAmount,
  isReturnToLossCredit,
} from "lib/return_to_loss_v2";
import { AppReducerStateProps } from "lib/store";
import getinfo from "lib/worker/api/getinfo";
import get_setting_return_to_loss, {
  GetSettingReturnToLossResponse,
} from "lib/worker/api/get_setting_return_to_loss";
import get_setting_return_to_loss_with_member from "lib/worker/api/get_setting_return_to_loss_with_member";
import return_to_loss_cliam from "lib/worker/api/return_to_loss_cliam";
import return_to_loss_transactions, {
  GetReturnToLossTransactionWithAdminResponse,
} from "lib/worker/api/return_to_loss_transactions";
import { GetServerSideProps } from "next";
import Link from "next/link";
import { useEffect, useState } from "react";
import { connect } from "react-redux";
import LayoutMaster from "../components/layout/layout_master";

interface Props {
  infomation: CheckWithPrefixResponse;
}

function ReturnLoss(props: Props) {
  const [transaction, settransaction] = useState<
    GetReturnToLossTransactionWithAdminResponse[]
  >([]);
  const [commission, setcommission] = useState<number>(0);
  const [commissionsetting, setcommissionsetting] =
    useState<GetSettingReturnToLossResponse>();

  const calCommisssion = (com: number): number => {
    return com;
  };

  const returnLossTitle = (amount: number): string => {
    return `คืนยอดเสียสูงสุด ${calCommisssion(amount).format(2, 0)} %`;
  };

  useEffect(() => {
    get_setting_return_to_loss_with_member({
      prefix: props.infomation.prefix,
    }).then(setcommission);
    get_setting_return_to_loss({
      prefix: props.infomation.prefix,
    }).then(setcommissionsetting);
  }, [props.infomation.prefix]);

  useEffect(() => {
    reload();
  }, []);

  const reload = () => {
    return_to_loss_transactions().then(settransaction);
  };

  const cliam = (transactionID: string) => {
    return_to_loss_cliam({ transaction_id: transactionID })
      .then(() => {
        return getinfo();
      })
      .catch((error: any) => {
        alertWithMessage(
          error.response?.data?.message ||
            error.response?.data?.Description ||
            "เกิดข้อผิดพลาด"
        );
      })
      .finally(() => {
        reload();
      });
  };

  if (commission == 0) {
    return (
      <LayoutMaster
        content_setting={{
          title: returnLossTitle(commission),
          description: "ระบบคืนยอดเสียเวลา 10:00 น. ตามเวลาไทย",
        }}
        information={props.infomation}
      ></LayoutMaster>
    );
  }

  const DisplayMainContent = () => {
    return (
      <>
        <h2 className="text-title">ขั้นตอนการรับกิจกรรม</h2>
        <ul>
          <li>
            ระบบคืนยอดเสียเวลา 10:00 น. ตามเวลาไทย
          </li>
          <li>
            คำนวณจากยอดเสียจริงคูณเปอร์เซ็นต์ที่กำหนด เช่น ยอดเสีย 1,000 คืน
            1% จะได้ 10
          </li>
          {!commissionsetting?.IsCredit && (
            <li>
              วิธีการแลกเพชร{" "}
              <Link href="/exchange">
                <a>
                  <span>คลิก</span>
                </a>
              </Link>{" "}
            </li>
          )}
        </ul>
        <p className="font-red">
          *นโยบายอาจเปลี่ยนแปลงไปตามที่บริษัทเป็นผู้กำหนด
          หากพยายามทุจริตหรือปลอมแปลงใดๆ จะมีกฏลงโทษแบนทันที
        </p>
      </>
    );
  };

  return (
    <LayoutMaster
      content_setting={{
        title: returnLossTitle(commissionsetting?.Amount ?? 0),
        description: "ระบบคืนยอดเสียเวลา 10:00 น. ตามเวลาไทย",
      }}
      information={props.infomation}
    >
      <div className="container" style={{ paddingTop: 20 }}>
        <h1 className="text-center">
          <span>
            คืนยอดเสียสูงสุด{" "}
            {calCommisssion(commissionsetting?.Amount ?? 0).format(2, 0)} %
          </span>
        </h1>
        <p className="text-center">สามารถคืนยอดเสียได้ทุกวัน!!</p>
        <div className="margin-top-20">
          {DisplayMainContent()}

          <div className="card-add-bg">
            <div className="card-table">
              <div
                className="card-add-headings"
                style={{ paddingTop: 10, paddingBottom: 10 }}
              >
                <span className="card-add-heading text-left">คืนยอด</span>
                <span className="card-add-heading text-center">สถานะ</span>
                <span className="card-add-heading text-center">วันที่</span>
                <span className="card-add-heading text-center">อัพเดต</span>
                <span className="card-add-heading text-right">รับรางวัล</span>
              </div>
              <div className="line-span" style={{ marginTop: 0 }}></div>
              <div className="row wrapper">
                {transaction.map((el, i) => {
                  const displayAmount = getReturnToLossDisplayAmount(el);
                  const isCredit = isReturnToLossCredit(
                    el,
                    commissionsetting?.IsCredit
                  );
                  const canClaim =
                    !el.Uncalculated && (!el.status || el.status === "pending");
                  return (
                    <div
                      key={i}
                      className="card-add"
                      style={{
                        paddingTop: 5,
                        paddingBottom: 0,
                      }}
                    >
                      <div className="font-card-add text-left">
                        {displayAmount.format(2, 0)}{" "}
                        {isCredit ? "เครดิต" : "เพชร"}
                      </div>
                      <div className="font-card-add text-center">
                        {!canClaim ? "รับแล้ว" : "ยังไม่ได้รับ"}
                      </div>
                      <div className="font-card-add">{el.DisplayCreatedAt}</div>
                      <div className="font-card-add text-center">
                        {el.DisplayUpdatedAt}
                      </div>
                      <div className="font-card-add">
                        <MaxButton
                          lock={!canClaim}
                          style={{ width: 70, float: "right" }}
                          title={"รับ"}
                          className={"bg-invite button-glowing"}
                          onClick={() => {
                            cliam(el.HashKey ?? "");
                          }}
                        ></MaxButton>
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
          </div>
        </div>
      </div>
    </LayoutMaster>
  );
}

export const getServerSideProps: GetServerSideProps<any> = async (context) => {
  const { req } = context;
  const infomation = CheckWithPrefix({ host: req.headers.host as string });
  return {
    props: {
      isLogin: context.req.cookies.access_token != undefined,
      infomation: infomation,
    },
  };
};

const mapStateToProps = (state: AppReducerStateProps) => {
  return {
    state: state,
  };
};

export default connect(mapStateToProps)(ReturnLoss);
